import { Form, FormType, WizardItemType, Zone } from '@gimlite/ui-v1';
import { useEffect, useState } from 'react';
import { ContractWizardInfos } from '../../../../composition/wizard-infos/contract.wizard-infos';
import { ContractBaseForm } from '../../../../form/contract-create/contract-create.form';
import { AddOneMotoristToAnExistingPoolContractWizardContext } from '../../addOneMotoristToAnExistingPoolContract.wizard';

export const ContractStep = ({
  context: { parentContract, contractBase: contract, product },
  validate,
  submit,
}: WizardItemType.Config.Component<AddOneMotoristToAnExistingPoolContractWizardContext>) => {
  const [instance, setInstance] = useState<
    FormType.HandleEvent.Instance['value1'] | null
  >(null);

  useEffect(() => {
    if (parentContract && !contract.articleCode) {
      submit({
        contractBase: { ...contract, articleCode: parentContract.articleCode },
      });
    }
  }, [parentContract, contract]);

  useEffect(() => {
    if (instance) {
      instance.validateFields({
        validateOnly: true,
        dirty: false,
        recursive: true,
      });
    }
  }, [instance]);

  return (
    <Form
      data={{ value: contract }}
      config={{ validateOnChange: true }}
      handleEvent={{
        change: (value: any) => {
          let contractFormatted = value;

          if (contractFormatted.APBMode === 'NONE') {
            contractFormatted = {
              ...contractFormatted,
              APBNext: null,
            };
          } else if (
            contractFormatted.APBMode !== 'NONE' &&
            [null, undefined].includes(contractFormatted.APBNext)
          ) {
            contractFormatted = {
              ...contractFormatted,
              APBNext: true,
            };
          }

          submit({ contractBase: contractFormatted });
        },
        validate: (value: boolean) => {
          validate(value);
        },
        instance: (form) => {
          setInstance(form);
        },
      }}
    >
      <Zone
        config={{
          gap: {
            y: 1,
            x: 1,
          },
          zones: [['info', 'form']],
          rows: ['1fr'],
          columns: ['min-content', '1fr'],
        }}
      >
        <Zone.Area config={{ area: 'info' }}>
          <ContractWizardInfos
            data={{
              APBMode: contract.APBMode,
              APBNext: contract.APBMode !== 'NONE' ? contract.APBNext : null,
              state: contract.state,
              startDate: contract.startDate,
              endDate: contract.endDate,
              description: contract.description,
              reference: contract.reference,
              articleCode: contract.articleCode,
            }}
          />
        </Zone.Area>

        {parentContract && contract.articleCode && (
          <Zone.Area config={{ area: 'form' }}>
            <ContractBaseForm
              data={{ contract }}
              config={{ parentContract, articleCodes: product.articleCodes }}
            />
          </Zone.Area>
        )}
      </Zone>
    </Form>
  );
};
